/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';

export interface GetWebSocketStatusRequest {
    sessionId: string;
}

/**
 * SessionEventsApi - interface
 * 
 * @export
 * @interface SessionEventsApiInterface
 */
export interface SessionEventsApiInterface {
    /**
     * Get statistics about active WebSocket connections
     * @summary Get WebSocket statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionEventsApiInterface
     */
    getWebSocketStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get statistics about active WebSocket connections
     * Get WebSocket statistics
     */
    getWebSocketStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Check if a session has an active WebSocket connection
     * @summary Get WebSocket connection status
     * @param {string} sessionId Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SessionEventsApiInterface
     */
    getWebSocketStatusRaw(requestParameters: GetWebSocketStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Check if a session has an active WebSocket connection
     * Get WebSocket connection status
     */
    getWebSocketStatus(requestParameters: GetWebSocketStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class SessionEventsApi extends runtime.BaseAPI implements SessionEventsApiInterface {

    /**
     * Get statistics about active WebSocket connections
     * Get WebSocket statistics
     */
    async getWebSocketStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/sessions/websocket/stats`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get statistics about active WebSocket connections
     * Get WebSocket statistics
     */
    async getWebSocketStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getWebSocketStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Check if a session has an active WebSocket connection
     * Get WebSocket connection status
     */
    async getWebSocketStatusRaw(requestParameters: GetWebSocketStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getWebSocketStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/sessions/{sessionId}/websocket/status`;
        urlPath = urlPath.replace(`{${"sessionId"}}`, encodeURIComponent(String(requestParameters['sessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Check if a session has an active WebSocket connection
     * Get WebSocket connection status
     */
    async getWebSocketStatus(requestParameters: GetWebSocketStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getWebSocketStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
